import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/config/brand";

/**
 * Shared shell for legal / static content pages. Reuses existing
 * card-soft styling so the visual system stays unchanged.
 */
export default function LegalPage({ eyebrow, title, updated, testid, children }) {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid={testid}>
      <Link to="/" className="btn-outline inline-flex items-center gap-2 text-sm mb-6" data-testid="legal-back-home">
        <ArrowLeft className="w-4 h-4" /> Home
      </Link>

      <span className="label-eyebrow">{eyebrow}</span>
      <h1 className="font-serif-display text-4xl sm:text-5xl mt-1 mb-2">{title}</h1>
      {updated && (
        <div className="text-xs mb-8" style={{ color: "var(--text-secondary)" }}>
          Last updated: {updated} · Applies to {BRAND.website.replace(/^https?:\/\//, "")}
        </div>
      )}

      <div className="card-soft p-8 space-y-5 leading-relaxed"
           style={{ color: "var(--text-primary)", fontSize: "0.97rem" }}>
        {children}
      </div>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-serif-display text-2xl mt-6 first:mt-0">{children}</h2>;
}
export function P({ children }) {
  return <p className="mt-2" style={{ color: "var(--text-secondary)" }}>{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-5 mt-2 space-y-1"
             style={{ color: "var(--text-secondary)" }}>{children}</ul>;
}
